export default __webpack_public_path__ + "static/media/ab-test-light-old.d0aaef71.svg";